import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 requestNumber: GetLocal('RequestNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowDetailedPlanReview", inputValue, ShowServiceResultSuccess);
    }, []);	
	
    const ShowServiceResultSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div> 
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			{getServiceResult ? <div>
			<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
				<tbody>
					<tr>
						<td><b class="b1">تراکم:</b> {getServiceResult.Density}</td>
						<td><b class="b1">کاربری زمین:</b> {getServiceResult.UsageDescription}</td>
						<td><b class="b1">محدوده:</b> {getServiceResult.ZoneTitle}</td>
					</tr>
					<tr>	
						<td><b class="b1">شماره نقشه:</b> {getServiceResult.MapNumber}</td>
						<td><b class="b1">ش پلاک گذربندی:</b> {getServiceResult.PlateCrossingNumber}</td>
						<td><b class="b1">حوزه پارکینگ:</b> {getServiceResult.Parking}</td>
					</tr>
					<tr>
						<td><b class="b1">نوع الویت:</b> {getServiceResult.PriorityName}</td>
						<td><b class="b1">حرایم:</b> {getServiceResult.PrivacyDescription}</td>
						<td><b class="b1">نظرات کارشناسی طرح تفصیلی:</b> {getServiceResult.DetailedPlanDescription}</td>
					</tr>
				</tbody>
			</table>	
			<br/>
			<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
				<tbody>
					<tr>
						<td><b class="b1">تجاوز به حریم گذرها (متراژ):</b> {getServiceResult.CrossingLength}</td>
						<td><b class="b1">تجاوز به حریم گذرها (مساحت):</b> {getServiceResult.CrossingArea}</td>
						<td><b class="b1">تجاوز به حریم املاک (متراژ):</b> {getServiceResult.ParcelPrivacyLength}</td>
					</tr>
					<tr>	
						<td><b class="b1">تجاوز به حریم املاک (مساحت):</b> {getServiceResult.ParcelPrivacyArea}</td>
						<td><b class="b1">مساحت پس از اصلاحی:</b> {getServiceResult.RemainedArea}</td>
					</tr>
				</tbody>
			</table>
			<br/>
			<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
				<thead>
					<tr>
						<th colspan="1" className="text-center"><b class="b1">جهت</b></th>
						<th colspan="1" className="text-center"><b class="b1">عرض گذر اصلاحی</b></th>
						<th colspan="1" className="text-center"><b class="b1">میزان عقب نشینی</b></th>
						<th colspan="1" className="text-center"><b class="b1">عرض گذر مجاور</b></th>
					</tr>
				</thead>			
				<tbody>
					{getServiceResult && [getServiceResult].map((item)=>(
						<>
							<tr>
								<td colspan="1" className="text-center">شمال</td>
								<td colspan="1" className="text-center">{item.RepairingNorth}</td>
								<td colspan="1" className="text-center">{item.RetreatingNorth}</td>
								<td colspan="1" className="text-center">{item.CrossingNorth}</td>
							</tr>
							<tr>
								<td colspan="1" className="text-center">شرق</td>
								<td colspan="1" className="text-center">{item.RepairingEast}</td>
								<td colspan="1" className="text-center">{item.RetreatingEast}</td>
								<td colspan="1" className="text-center">{item.CrossingEast}</td>
							</tr>	
							<tr>
								<td colspan="1" className="text-center">جنوب</td>
								<td colspan="1" className="text-center">{item.RepairingSouth}</td>
								<td colspan="1" className="text-center">{item.RetreatingSouth}</td>
								<td colspan="1" className="text-center">{item.CrossingSouth}</td>
							</tr>		
							<tr>
								<td colspan="1" className="text-center">غرب</td>
								<td colspan="1" className="text-center">{item.RepairingWest}</td>
								<td colspan="1" className="text-center">{item.RetreatingWest}</td>
								<td colspan="1" className="text-center">{item.CrossingWest}</td>
							</tr>								
						</>	
					))}		
				</tbody>
			</table>	
			<br/>
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.DimentionDetailsInfoList}
				customHeaders={{
					"DimensionsSide": "جهت",
					"LengthSide": "طول ضلع",
					"LimitTitle": "حد",
					"CrossWidth": "عرض گذر",
					"StreetName": "نام معبر",
					"Description": "توضیحات"
				}}		
			/>				
			<br/>
			<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>			
				<tbody>
					<tr>
						<td><b class="b1">نظرات کارشناسی بروکف:</b> {getServiceResult.ParcelLimitDescription}</td>
						<td><b class="b1">توضیحات ارسال:</b> {getServiceResult.SentDescription}</td>
					</tr>	
				</tbody>
			</table>			
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>			
    );
}
